import enfieldGeojson from '../data/EnfieldArea.geojson';

export const getRainfallEventArea = () => {
  return enfieldGeojson;
};
